// extracted by mini-css-extract-plugin
export default {"form":"Form_form__e1yzW","input-group":"Form_input-group__00++L","actions":"Form_actions__GfNR-","button":"Form_button__8NOIT","buttonAlt":"Form_buttonAlt__jd4gh"};